import lottie, { AnimationItem } from 'lottie-web';
import { useEffect, useRef } from 'react';

import { Center, useColorMode } from '@vimeo/bokeh';
import { HeartFilled } from '@vimeo/bokeh-icons';

import { HoverAnimatedIcon } from './HoverAnimatedIcon';

export const AnimatedLikeIcon = ({
  likedVideo,
  isAnimating,
  setIsAnimating,
}: {
  likedVideo: boolean;
  isAnimating: boolean;
  setIsAnimating: (value: boolean) => void;
}) => {
  const lottieRef = useRef<AnimationItem | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { colorMode } = useColorMode();

  useEffect(() => {
    if (containerRef.current) {
      if (lottieRef.current) {
        lottieRef.current.destroy();
      }
      lottieRef.current = lottie.loadAnimation({
        container: containerRef.current as Element,
        loop: false,
        autoplay: false,
        path: `https://f.vimeocdn.com/motion/bokeh_heart_click_${colorMode}.json`,
      });

      lottieRef.current.addEventListener('complete', () => {
        setIsAnimating(false);
      });
    }
  }, [colorMode]);

  useEffect(() => {
    if (isAnimating) {
      // Play click animation when transitioning from unliked to liked
      if (lottieRef.current) {
        lottieRef.current.goToAndStop(0, true);
        lottieRef.current.play();
      }
    }
  }, [isAnimating]);

  return (
    <Center boxSize="xs" position="relative">
      {!likedVideo && !isAnimating && (
        <Center position="absolute" zIndex={3} top="2px" left="2px">
          <HoverAnimatedIcon iconName="heart" />
        </Center>
      )}

      {likedVideo && !isAnimating && (
        <Center position="absolute" zIndex={3} top="2px" left="2px">
          <HeartFilled color="#FB1409" boxSize="sm" />
        </Center>
      )}

      <Center
        ref={containerRef}
        position="absolute"
        top="1px"
        left="1px"
        boxSize="22px"
        zIndex={isAnimating ? 3 : 0}
        opacity={isAnimating ? 1 : 0}
        pointerEvents="none"
      />
    </Center>
  );
};
